import type { CSSProperties, ReactNode } from 'react';

/** Convert a #RRGGBB hex string to an rgba() string at the given alpha. */
export function hexToRgba(hex: string, alpha: number): string {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

/**
 * Inline style for a status badge driven by a configurable hex color: a faint
 * tinted background with the full color as the text/border. Falls back to a
 * neutral gray when the color is missing or not a hex value. Shared by the
 * expense and planning status badges so colors render identically.
 */
export function statusBadgeStyle(color: string | null | undefined): CSSProperties {
  if (!color || !color.startsWith('#')) {
    return { backgroundColor: '#F3F4F6', color: '#374151' };
  }
  return { backgroundColor: hexToRgba(color, 0.15), color };
}

export interface StatusPillProps {
  label: ReactNode;
  /** Configurable hex color (e.g. "#3B82F6"); falls back to gray when absent. */
  color?: string | null;
  className?: string;
}

/** A pill badge tinted by a configurable hex status color. */
export function StatusPill({ label, color, className }: StatusPillProps) {
  return (
    <span
      style={statusBadgeStyle(color)}
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${className ?? ''}`}
    >
      {label}
    </span>
  );
}
